module.exports = __webpack_public_path__ + "static/media/weibo-dark.6d02427d.svg";